import { createSelector } from 'reselect'

export const getFilters = state => state.appliedFilters

export const areFiltersLocked = createSelector(
    getFilters,
    filters => filters.locked !== undefined ? filters.locked : false
)

export const getContrast = createSelector(
    getFilters,
    filters => filters.contrast,
)

export const getBrightness = createSelector(
    getFilters,
    filters => filters.brightness,
)

export const getUserScale = createSelector(
    getFilters,
    (filters) => filters.scale,
)

export const getRotation = createSelector(
    getFilters,
    filters => filters.rotate,
)

export const isBrightnessActive = createSelector(
    getBrightness,
    // TODO FIXME remplacer par DEFAULT_BRIGHTNESS > HS si import const depuis reducer (dépendances croisées ?)
    brightness => brightness !== 0
)

export const isContrastActive = createSelector(
    getContrast,
    // TODO FIXME remplacer par DEFAULT_BRIGHTNESS > HS si import const depuis reducer (dépendances croisées ?)
    contrast => contrast !== 0
)

export const isInvertActive = createSelector(
    getFilters,
    filters => filters.invert !== undefined ? filters.invert : false
)

export const isZoomActive = createSelector(
    getUserScale,
    scale => scale !== 1
)

export const areFiltersApplied = createSelector(
    isContrastActive,
    isBrightnessActive,
    isInvertActive,
    (isContrastActive, isBrightnessActive, isInvertActive) => (isContrastActive || isBrightnessActive || isInvertActive)
)

export const getScaleStep = createSelector(
    getFilters,
    filters => filters.scaleStep
)
